export default {
    edit_scheduled_action_title: "Edit Scheduled Action",
    edit_scheduled_action_success_message: "The scheduled action has been edited",
    edit_scheduled_action_error_message: "The scheduled action was not edited due to an error",
    edit_scheduled_status: "Status",
    edit_scheduled_scheduled_at: "Scheduled At",
    edit_scheduled_already_scheduled_action: "The entity already has an scheduled action for that date",
}